import { render, staticRenderFns } from "./videoZb.vue?vue&type=template&id=6887a5e2&"
import script from "./videoZb.vue?vue&type=script&lang=js&"
export * from "./videoZb.vue?vue&type=script&lang=js&"
import style0 from "./videoZb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports